export default "__VITE_ASSET__e1b1bc02__"